import { render, staticRenderFns } from "./MontagemCarga.vue?vue&type=template&id=28374404"
import script from "./MontagemCarga.vue?vue&type=script&lang=js"
export * from "./MontagemCarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports